import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Card } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { ReportCard } from "../../../../components/Admin/Report/ReportCard";
import { CoursesByTeacher, StudentsByGrade, AttendancesByGrade } from "../../../../components/Admin/Report/Admin";
import { usePermissions } from "../../../../hooks";
import "./Admin.scss";

export function Admin() {
  const { hasPermission } = usePermissions();
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({ title: "", component: null });

  if (!hasPermission("user", "read")) {
    return <Navigate to="/admin" replace />;
  }

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const openCoursesByTeacher = () => {
    setModalConfig({
      title: "Reporte de Cursos por Docente",
      component: <CoursesByTeacher onClose={onOpenCloseModal} />,
    });
    onOpenCloseModal();
  };

  const openStudentsByGrade = () => {
    setModalConfig({
      title: "Reporte de Estudiantes por Grado",
      component: <StudentsByGrade onClose={onOpenCloseModal} />,
    });
    onOpenCloseModal();
  };

  const openAttendancesByGrade = () => {
    setModalConfig({
      title: "Reporte de Asistencia por Grado",
      component: <AttendancesByGrade onClose={onOpenCloseModal} />,
    });
    onOpenCloseModal();
  };

  const reports = [
    {
      title: "Cursos por Docente",
      icon: "user",
      onClick: openCoursesByTeacher,
    },
    {
      title: "Estudiantes por Grado",
      icon: "users",
      onClick: openStudentsByGrade,
    },
    {
      title: "Asistencia Mensual",
      icon: "calendar check",
      onClick: openAttendancesByGrade,
    },
  ];

  return (
    <>
      <div className="admin-page m-2">
        <Card.Group itemsPerRow={3} stackable>
          {reports.map((report, index) => (
            <ReportCard
              key={index}
              title={report.title}
              icon={report.icon}
              onClick={report.onClick}
            />
          ))}
        </Card.Group>

        <BasicModal
          show={showModal}
          close={onOpenCloseModal}
          title={modalConfig.title}
          size="small"
        >
          {modalConfig.component}
        </BasicModal>
        
      </div>
    </>
  );
}
